import { Component, OnInit, Input } from '@angular/core';
import { Company } from '../../classes/company';
import { ActivatedRoute } from '@angular/router';
import { CompanyService } from '../../services/company.service';
import { publicMethods } from '../../globals';
declare var $: any;
import { MessageService } from '../../services/message.service';
declare var zE: any; // Zendesk SDK variable

@Component({
  selector: 'app-company-clusters',
  templateUrl: './company-clusters.component.html',
  styleUrls: ['./company-clusters.component.css'],
})

export class CompanyClustersComponent implements OnInit {
  companyId: string;
  isLoadingCorporateStructureGraph: boolean;
  corporateStructureGraph: any;
  clusters: any = []; // clusters are calculated from the graph

  @Input()
  company: Company;

  constructor(
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private messageService: MessageService, // retain this so we can show errors
  ) { }

  ngOnInit() {
    var id = this.route.snapshot.paramMap.get('id');
    this.companyId = id;
    this.companyService.getCompany(<string>id).subscribe(data => {
      this.company = data.company;
      this.getCompanyGraphInformation();
    });
  }

  getCompanyGraphInformation(): void {
    this.isLoadingCorporateStructureGraph = true;
    this.companyService
      .getCorporateStructureGraphWithClusters(<string>this.companyId)
      .subscribe(graphInfo => {

        this.createClustersFromGraph(graphInfo);
        console.log(this.clusters);
        this.updateCorporateStructureGraph(graphInfo);
      });
  }

  createClustersFromGraph(graphInfo: any) {
    let clustersMap = {};
    graphInfo.corporate_structure_graph.nodes.forEach(node => {
      if (node.cluster_id) {
        let clusterId = node.cluster_id.toString();

        if (!clustersMap[clusterId]) {
          clustersMap[clusterId] = {
            id: clusterId,
            label: 'Cluster ' + clusterId,
            childNodeIds: [node.id]
          };
        } else {
          clustersMap[clusterId].childNodeIds.push(node.id);
        }
      }
    });

    // Convert to array
    this.clusters = Object.values(clustersMap);
  }

  updateCorporateStructureGraph(graphInfo) {
    this.corporateStructureGraph = graphInfo['corporate_structure_graph'];
    this.isLoadingCorporateStructureGraph = false;
  }

  generateDirectorsList(directors) {
    return '<ul>' + directors.map(id => `<li>${id}</li>`).join('') + '</ul>';
  }

}
